import { HttpErrorResponse } from '@angular/common/http';
import { Component, input } from '@angular/core';

import { FormComponent } from '@camelot/form-basic';
import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, DepartmentProfessionsComponent, LoaderComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../../translation.service';
import { BaseTemplateComponent } from '../base-template';

@Component({
  selector: 'cam-return-template',
  templateUrl: './return-template.component.html',
  styleUrls: ['./return-template.component.scss'],
  imports: [DepartmentProfessionsComponent, FormComponent, LoaderComponent, ButtonComponent, TranslatePipe],
})
export class ReturnTemplateComponent extends BaseTemplateComponent {
  ctaService = input.required<{
    returnBack: (id: number, request: { isSuccess: boolean }) => any;
  }>();

  formService = input.required<{
    getReturnForm: () => any;
    formatReturnResult: (data: any) => { isSuccess: boolean };
  }>();

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public setForm() {
    this.form.set(this.formService().getReturnForm());
  }

  public override send(data: any) {
    const request = this.formService().formatReturnResult(data);

    this.requestState.asked();
    this.ctaService()
      .returnBack(this.currentItem.id, request)
      .subscribe({
        complete: () => {
          this.next();
          this.requestState.completed();
        },
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      });
  }
}
